import React, { useEffect, useState, useRef, Component,Router, props } from "react";
import Footer from "../../Home/Home_modules/Footerr/footer";
import './blog.css'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

export default class Blog_inner extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            postData: [],
            postTitle: '',
            postContent: ""
        }
    }
    componentWillMount(){
        const postSlug = this.props.match.params.postSlug;
        console.log(postSlug);
        fetch('//temp.gadgetsfresh.com/wp-json/wp/v2/posts?slug='+ postSlug)
        .then(res => res.json())
        .then(data => {
       //  console.log(data[0]);
         this.setState({postData : data[0]});
         //console.log(this.state.postData);
         this.setState({postTitle : data[0].title.rendered});
         this.setState({postContent : data[0].content.rendered});
         //console.log(this.state.postTitle);
        const postContent = document.getElementById("postContent");
        postContent.innerHTML = this.state.postContent;
     document.title = this.state.postTitle + " | Diginoor ";
        
    })
    .catch(err => console.log(err));
    }
    render(){
        return(

        <>
        <SkeletonTheme baseColor="#D3D3D3" highlightColor="#5c5c5b" duration={1.5}>
        <div className ="main">
        <div className ="postim">
            <img src={this.state.postData.featured_media_src_url} alt="post-main-image"/>
        </div>
        <div className ="post-content">
            <h1>{this.state.postTitle}</h1>
            <div className="post-meta">
                <a>admin</a>
                <a>{this.state.postData.date}</a>
            </div>
            <div className="post-content-text">
                <p id="postContent" dangerouslySetInnerHTML={{__html:this.state.postContent} }/>
            </div>
        </div>
        </div>
        </SkeletonTheme>
        <Footer/>
        </>
    )
        }
}